import React from 'react';
export default function ScarfSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 14C8 14 14 18 20 18C26 18 32 14 32 14V20C32 20 26 24 20 24C14 24 8 20 8 20V14Z" fill="#43A047" />
      <rect x="16" y="22" width="8" height="14" rx="2" fill="#43A047" />
      <rect x="16" y="26" width="8" height="2" fill="#2E7D32" />
      <rect x="16" y="32" width="8" height="2" fill="#2E7D32" />
      <rect x="8" y="16" width="24" height="2" fill="#2E7D32" />
    </svg>
  );
}
